/**
 * @file  pagination/rc-pagination/Options
 * @author chenyaqiu
 */
import React from 'react';
;
const defaultPageSizeOptions = ['10', '20', '50', '100'];
const Options = ({ pageSizeOptions = defaultPageSizeOptions, changeSize, pageSize, rootPrefixCls, selectComponentClass, buildOptionText, selectPrefixCls, disabled, Option, locale }) => {
    const prefixCls = `${rootPrefixCls}-options`;
    const Select = selectComponentClass;
    const handleBuildOptionText = React.useCallback(value => `${value}`, []);
    buildOptionText = React.useCallback(value => `${value} ${locale.items_per_page}`, [locale]);
    const handleChangeSize = React.useCallback(value => {
        changeSize(Number(value));
    }, [changeSize]);
    const curPageSizeOptions = React.useMemo(() => {
        if (pageSizeOptions.some(option => option.toString() === pageSize.toString())) {
            return pageSizeOptions;
        }
        return pageSizeOptions.concat([pageSize.toString()]).sort((a, b) => {
            // eslint-disable-next-line no-restricted-globals
            const numberA = isNaN(Number(a)) ? 0 : Number(a);
            // eslint-disable-next-line no-restricted-globals
            const numberB = isNaN(Number(b)) ? 0 : Number(b);
            return numberA - numberB;
        });
    }, [pageSize, pageSizeOptions]);
    const changeSelect = React.useMemo(() => {
        if (changeSize && Select) {
            const options = curPageSizeOptions.map(opt => (<Option key={opt.toString()} value={opt.toString()}>
                    {(buildOptionText || handleBuildOptionText)(opt)}
                </Option>));
            return (<Select disabled={disabled} prefixCls={selectPrefixCls} showSearch={false} className={`${prefixCls}-size-changer`} optionLabelProp="children" dropdownMatchSelectWidth={false} value={(pageSize || curPageSizeOptions[0]).toString()} onChange={handleChangeSize} getPopupContainer={triggerNode => triggerNode.parentNode}>
                    {options}
                </Select>);
        }
        return null;
    }, [
        Select,
        buildOptionText,
        changeSize,
        handleChangeSize,
        disabled,
        pageSize,
        curPageSizeOptions,
        handleBuildOptionText,
        prefixCls,
        selectPrefixCls,
        Option
    ]);
    if (!changeSize || !Select) {
        return null;
    }
    return (<li className={`${prefixCls}`}>
            {changeSelect}
        </li>);
};
export default Options;
